"use strict";

exports.__esModule = true;
exports.attributeMapper = exports.ENVIRONMENT = void 0;
var attributeMapper = {
  Argos: 'Argos',
  Beauty: 'Beauty',
  'Countdown to Christmas': 'CountdownToChristmas',
  'Customer Experience': 'CustomerExperience',
  Event: 'Event',
  Food: 'Food',
  'Food Production': 'FoodProduction',
  'Food Services': 'FoodServices',
  'GM & Clothing': 'GmAndClothing',
  'Groceries Online': 'GroceriesOnline',
  Habitat: 'Habitat',
  'Line Managers': 'LineManagers',
  'Night / twilight shift': 'NightTwilightShift',
  Risk: 'Risk',
  'Running the Store': 'RunningTheStore',
  Christmas: 'Christmas'
};
exports.attributeMapper = attributeMapper;

var getEnvironment = function getEnvironment() {
  var host = window.location.host;

  if (host.match('^[a-zA-Z0-9]*-dev.retail-azure.js-devops.co.uk$')) {
    return 'dev';
  }

  if (host.match('^[a-zA-Z0-9]*-test.retail-azure.js-devops.co.uk$')) {
    return 'test';
  }

  if (host.match('^[a-zA-Z0-9]*-preprod.retail-azure.js-devops.co.uk$')) {
    return 'preprod';
  }

  if (host.match('^[a-zA-Z0-9]*.sainsburys.co.uk$')) {
    return 'prod';
  }

  return 'dev';
};

var ENVIRONMENT = getEnvironment();
exports.ENVIRONMENT = ENVIRONMENT;